import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { baseURL, headers } from '@/v2/constants/requests'

export const useTasks = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['Tasks'],
    queryFn: async () => {
      const res = await fetch(`${baseURL}/v2/rest/tasks`)
      if (!res.ok) {
        throw new Error("We couldn't find any tasks")
      }
      const result = await res.json()
      return result
    },
  })

  return { tasks: data, isLoading, isError }
}

export const useAddTask = () => {
  const queryClient = useQueryClient()

  const { mutateAsync: addTask, ...rest } = useMutation({
    mutationFn: async taskData => {
      const res = await fetch(`${baseURL}/v2/rest/tasks`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ task: taskData }),
      })
      if (!res.ok) {
        const error = await res.json()
        throw new Error(error.message || 'Could not create task')
      }
      return res.json()
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['Tasks'])
    },
  })

  return { addTask, ...rest }
}

export const useUpdateTask = taskId => {
  const queryClient = useQueryClient()

  const { mutateAsync: updateTask, ...rest } = useMutation({
    mutationFn: async taskData => {
      const res = await fetch(`${baseURL}/v2/rest/tasks/${taskId}`, {
        method: 'PUT',
        headers,
        body: JSON.stringify({ task: taskData }),
      })
      if (!res.ok) {
        const error = await res.json()
        throw new Error(error.message || 'Could not update task')
      }
      return res.json()
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['Tasks'])
    },
  })

  return { updateTask, ...rest }
}

export const useDeleteTask = taskId => {
  const queryClient = useQueryClient()

  const { mutateAsync: deleteTask, ...rest } = useMutation({
    mutationFn: async () => {
      const res = await fetch(`${baseURL}/v2/rest/tasks/${taskId}`, {
        method: 'DELETE',
        headers,
      })
      if (!res.ok) {
        const error = await res.json()
        throw new Error(error.message || 'Could not delete task')
      }
      return res.json()
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['Tasks'])
    },
  })

  return { deleteTask, ...rest }
}
